import { render } from "./OrganicQuestions.vue?vue&type=template&id=03b9dc67&scoped=true"
import script from "./OrganicQuestions.vue?vue&type=script&lang=js"
export * from "./OrganicQuestions.vue?vue&type=script&lang=js"

import "./OrganicQuestions.vue?vue&type=style&index=0&id=03b9dc67&scoped=true&lang=css"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b9dc67"]])

export default __exports__